<mat-form-field class="form-element">
    <input matInput type="{{to.type}}" placeholder="{{to.label}}" [formControl]="formControl" [formlyAttributes]="field" (change)="valueChangeFn(field.key, field.id, $event)">
</mat-form-field>